module.exports = __webpack_public_path__ + "img/system5.fe1b9f8f.svg";